/* MMO cursor ring + magnetic buttons (demo port; desktop fine-pointer only) */
(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !matchMedia('(pointer:fine)').matches || innerWidth <= 900) return;
  var cur = document.createElement('div');
  cur.className = 'mmo-cursor';
  document.body.appendChild(cur);
  var cx = innerWidth / 2, cy = innerHeight / 2, tx = cx, ty = cy;
  addEventListener('mousemove', function (e) { tx = e.clientX; ty = e.clientY; cur.style.opacity = 1; });
  (function loop() { cx += (tx - cx) * 0.18; cy += (ty - cy) * 0.18; cur.style.transform = 'translate(' + cx + 'px,' + cy + 'px) translate(-50%,-50%)'; requestAnimationFrame(loop); })();
  document.addEventListener('mouseover', function (e) { if (e.target.closest('a,button,summary,.btn,.go')) cur.classList.add('big'); });
  document.addEventListener('mouseout', function (e) { if (e.target.closest('a,button,summary,.btn,.go')) cur.classList.remove('big'); });
  document.querySelectorAll('.mmo .btn').forEach(function (b) {
    b.addEventListener('mousemove', function (e) { var r = b.getBoundingClientRect(); var dx = e.clientX - (r.left + r.width / 2); var dy = e.clientY - (r.top + r.height / 2); b.style.transform = 'translate(' + dx * 0.18 + 'px,' + dy * 0.3 + 'px)'; });
    b.addEventListener('mouseleave', function () { b.style.transform = ''; });
  });
})();
